// extracted by mini-css-extract-plugin
export var copyIcon = "_rs-2";
export var discountCard = "_rs-0";
export var discountCode = "_rs-3";
export var discountContent = "_rs-1";
export var loadingCard = "_rs-4";